export const events = {
    productOpened: {
        name: "Product Opened",
        requiredFields: ["product"],
    },
};
